import { render, staticRenderFns } from "./PersonInfor.vue?vue&type=template&id=603ee710&scoped=true&"
import script from "./PersonInfor.vue?vue&type=script&lang=js&"
export * from "./PersonInfor.vue?vue&type=script&lang=js&"
import style0 from "./PersonInfor.vue?vue&type=style&index=0&id=603ee710&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603ee710",
  null
  
)

export default component.exports